import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./auth"; // Importation de auth.js
// Icônes « fas fa-… » utilisées en classes CSS dans plusieurs écrans
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./assets/styles.css";
import "./assets/form-page.css";
import { registerServiceWorker } from "./api/push.js";

createApp(App).use(router).mount("#app");

// Application installable + notifications push (public/sw.js)
registerServiceWorker();
